import {PageHeader} from "@/layout/components/PageHeader.tsx";
import {PageWrapper} from "@/layout/components/PageWrapper.tsx";
import {Card, CardContent, CardDescription, CardHeader, CardTitle} from "@/components/ui/card.tsx";
import {PaymentMethod} from "@/pages/system-account/components/PaymentMethod.tsx";
import {useCurrentSystem} from "@/hooks/useCurrentSystem.tsx";
import {Navigate} from "react-router";
import {toast} from "sonner";

export function SystemAccount() {

    const {role} = useCurrentSystem();

    if(role && role !== 1) {
        toast.info('רק בעלים יכול לנהל את חשבון המערכת')
        return (
            <Navigate to="/" replace={true} state={{from: '/system/account'}} />
        );
    }

    return (
        <PageWrapper>
            <PageHeader title="חשבון מערכת"/>

            <div className="grid gap-8">
                <Card>
                    <CardHeader>
                        <CardTitle>מערכות מחוברות</CardTitle>
                        <CardDescription>
                            כלל המערכות המחוברות לחשבון זה
                        </CardDescription>
                    </CardHeader>
                    <CardContent>

                    </CardContent>
                </Card>

                <PaymentMethod/>
            </div>
        </PageWrapper>
    )
}